import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { apiErr, fmtDate } from "@/lib/api";
import { Loading } from "@/components/site/ui";
import { Panel, AdminHeading } from "@/components/admin/ui";

export default function AdminGuestbook() {
  const [items, setItems] = useState(null);
  const load = () => api.get("/admin/guestbook").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  const mod = async (id, body) => { try { await api.put(`/admin/guestbook/${id}`, body); toast.success("Updated."); load(); } catch (e) { toast.error(apiErr(e)); } };

  return (
    <div>
      <AdminHeading title="Guestbook Moderation" subtitle="Approve entries before they appear publicly. Nothing is published automatically." />
      {items === null ? <Loading /> : items.length === 0 ? <Panel><p className="text-sm text-muted-foreground py-4 text-center">No guestbook entries yet.</p></Panel> : (
        <div className="space-y-3">
          {items.map((g) => (
            <Panel key={g.id}>
              <p className="font-serif text-lg italic">"{g.message}"</p>
              <p className="text-xs text-gold mt-2">— {g.name}{g.visit_date ? ` · ${fmtDate(g.visit_date)}` : ""} · wants public: {g.allow_public ? "yes" : "no"}</p>
              <div className="flex gap-2 mt-3">
                <button onClick={() => mod(g.id, { approved: true, public: g.allow_public, status: "approved" })} className="btn-ghost-gold px-3 py-1.5 text-xs" data-testid={`gb-approve-${g.id}`}>Approve{g.allow_public ? " (public)" : " (private)"}</button>
                <button onClick={() => mod(g.id, { featured: !g.featured })} className="btn-ghost-gold px-3 py-1.5 text-xs">{g.featured ? "Unfeature" : "Feature"}</button>
                <button onClick={() => mod(g.id, { approved: false, public: false, status: "removed" })} className="px-3 py-1.5 text-xs text-red-300 border border-red-400/30 rounded-full">Remove</button>
                <span className="ml-auto text-xs text-muted-foreground self-center">{g.approved ? (g.public ? "Public" : "Approved (private)") : "Pending"}</span>
              </div>
            </Panel>
          ))}
        </div>
      )}
    </div>
  );
}
